import { Badge, Flex, Stack, Text } from '@chakra-ui/react';

interface IOwnProps {
  title: string;
  classification: string;
  status: string;
  isFinalResult?: boolean;
}

const ClassificationBoxMobilePage: React.FC<IOwnProps> = ({ title, classification, status, isFinalResult }) => {
  return (
    <Flex
      justify="space-between"
      align="center"
      px={4}
      py={3}
      borderColor={`${isFinalResult ? 'green' : 'yellow'}.500`}
      borderWidth={1}
      borderRadius="lg"
      shadow="sm"
      _hover={{ shadow: 'md', bg: 'white' }}
    >
      <Stack gap={0}>
        <Text fontWeight="semibold" mb={2}>
          {title}
        </Text>
        <Badge
          w="fit-content"
          colorScheme={`${isFinalResult ? 'green' : 'yellow'}`}
          borderRadius="md"
          fontSize="0.7rem"
          px={2}
          mt={-1}
        >
          {status}
        </Badge>
      </Stack>

      <Stack justify="space-between" align="center" gap={1}>
        <Stack gap={0} color={`${isFinalResult ? 'green' : 'yellow'}.500`}>
          <Text pl={3} py={0} borderRadius="md" fontSize="2xl">
            {classification}º
          </Text>
        </Stack>
      </Stack>
    </Flex>
  );
};

export default ClassificationBoxMobilePage;
